import script from "./indexMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./indexMobile.vue?vue&type=script&setup=true&lang=ts"

import "./indexMobile.vue?vue&type=style&index=0&id=56c482c7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c482c7"]])

export default __exports__